module.exports = __webpack_public_path__ + "static/media/cloud_0.e679e533.png";